import { useEffect } from "react";
import clarity from "@microsoft/clarity";

const ClarityScript = () => {
  useEffect(() => {
    const clarityId = process.env.REACT_APP_CLARITY_ID;

    if (clarityId) {
      clarity.init(clarityId);
      // console.log("Microsoft Clarity zainicjalizowana z ID:", clarityId);
    } else {
      // console.warn("Brak VITE_CLARITY_ID w zmiennych środowiskowych");
    }
  }, []);

  return null;
};

export default ClarityScript;
